import React, { Component } from 'react';
import { Link, Navigate } from "react-router-dom";
import axios from "../../utils/axiosInstance";
import Search from './Search';

class MenuMain extends Component {

    state = {
        website_name: "",
        description: "",
        website_logo: null,
        whatsapp_number: "",
        address: "",
        phone: "",
        currency_symbol: "", 
        email: "",
        social_link_1: "",
        social_link_2: "",
        social_link_3: "",
        social_link_4: "",
        powered_by: "",
        preview_logo: null,
        wishlistCount: 0,
        cartCount: 0,
        redirectToLogin: false
    };

    API_BASE = axios.defaults.baseURL;
    PUBLIC_BASE = this.API_BASE.replace("/api", "");

    componentDidMount() {

        this.fetchFooterData();
        this.updateWishlistCount();
        this.updateAddToCartCount();
        window.addEventListener("wishlistUpdated", this.updateWishlistCount);
        window.addEventListener("cartUpdated", this.updateAddToCartCount);
        window.addEventListener("storage", () => this.forceUpdate());

    }

    componentWillUnmount() {
        window.removeEventListener("wishlistUpdated", this.updateWishlistCount);
        window.removeEventListener("cartUpdated", this.updateAddToCartCount);
    }

    fetchFooterData = async () => {
        try {
            const res = await axios.get("/theme_customizable");
            const d = res?.data?.data;
            if (d) {
                this.setState({
                    website_name: d.website_name || "",
                    description: d.description || "",
                    whatsapp_number: d.whatsapp_number || "",
                    address: d.address || "",
                    phone: d.phone || "",
                    email: d.email || "",
                    social_link_1: d.social_link_1 || "",
                    social_link_2: d.social_link_2 || "",
                    social_link_3: d.social_link_3 || "",
                    social_link_4: d.social_link_4 || "",
                    preview_logo: d.website_logo
                        ? `${this.PUBLIC_BASE}/${d.website_logo}`
                        : null,
                });
            }
        } catch (error) {
            console.error("Footer fetch error:", error);
        }
        try {
            const res1 = await axios.get("/setting", {});
            const d = res1?.data?.data;
            if (d) {
                this.setState({
                    powered_by: d.powered_by || "",
                    currency_symbol: d.currency_symbol || "",
                });
            }
        } catch (error) {
            console.error("Footer fetch error:", error);
        }
    };

    updateWishlistCount = () => {
        const wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];
        this.setState({ wishlistCount: wishlist.length });
    };

    updateAddToCartCount = () => {
        const cart = JSON.parse(localStorage.getItem("cart")) || [];
        const totalQty = cart.reduce((sum, item) => sum + Number(item.qty || 1), 0);
        this.setState({ cartCount: totalQty });
    };

    getCartTotal = () => {
        const cart = JSON.parse(localStorage.getItem("cart")) || [];
        return cart.reduce((sum, item) => sum + item.qty * item.price, 0);
    };

    removeFromCart = (productId) => {
        let cart = JSON.parse(localStorage.getItem("cart")) || [];
        cart = cart.filter(item => item.id !== productId);
        localStorage.setItem("cart", JSON.stringify(cart));
        this.setState({ cartCount: cart.reduce((sum, item) => sum + item.qty, 0) });
        window.dispatchEvent(new Event("cartUpdated"));
    };

    isCustomerLoggedIn = () => { return !!localStorage.getItem("token"); };

    handleLogout = () => {
        localStorage.clear();
        this.setState({ redirectToLogin: true });
    };

    render() {
        const {
            preview_logo,
            phone,
            currency_symbol,
            powered_by,
            social_link_1,
            social_link_2,
            social_link_3,
            social_link_4,
            wishlistCount,
            cartCount,
        } = this.state;

        if (this.state.redirectToLogin) {
            return <Navigate to="/login" replace />;
        }

        return (
            <>
                


                
            </>
        );
    }
}

export default MenuMain;
